import { render, staticRenderFns } from "./table-3.vue?vue&type=template&id=1368687f&scoped=true"
import script from "./table-3.vue?vue&type=script&lang=js"
export * from "./table-3.vue?vue&type=script&lang=js"
import style0 from "./table-3.vue?vue&type=style&index=0&id=1368687f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1368687f",
  null
  
)

export default component.exports